// Cart utility functions for managing cart in localStorage
import { isUserLoggedIn } from "./authUtils";

export const getCartItems = () => {
  try {
    const storedCart = localStorage.getItem("cart");
    if (storedCart) {
      return JSON.parse(storedCart);
    }
  } catch (error) {
    console.error("Error reading cart from localStorage:", error);
  }
  return [];
};

export const saveCartItems = (items) => {
  try {
    localStorage.setItem("cart", JSON.stringify(items));
    // Dispatch custom event to notify other components
    window.dispatchEvent(new CustomEvent("cartUpdated", { detail: items }));
  } catch (error) {
    console.error("Error saving cart to localStorage:", error);
  }
};

export const addToCart = (product, onLoginRequired) => {
  // Check if user is logged in
  if (!isUserLoggedIn()) {
    // Call the callback to show login modal if provided
    if (onLoginRequired && typeof onLoginRequired === "function") {
      onLoginRequired();
    }
    return null; // Return null to indicate login is required
  }

  const cartItems = getCartItems();
  
  // Check if product already exists in cart
  const existingItemIndex = cartItems.findIndex((item) => item.id === product.id);
  
  if (existingItemIndex >= 0) {
    // If exists, increment quantity
    cartItems[existingItemIndex].quantity += product.quantity || 1;
  } else {
    // If not exists, add new item
    const cartItem = {
      id: product.id,
      name: product.name || product.title,
      price: product.price || 0,
      quantity: product.quantity || 1,
      image: product.image || "",
      ...product, // Include any other product properties
    };
    cartItems.push(cartItem);
  }
  
  saveCartItems(cartItems);
  return cartItems;
};

export const removeFromCart = (productId) => {
  const cartItems = getCartItems();
  const filteredItems = cartItems.filter((item) => item.id !== productId);
  saveCartItems(filteredItems);
  return filteredItems;
};

export const updateCartItemQuantity = (productId, quantity) => {
  const cartItems = getCartItems();
  const updatedItems = cartItems.map((item) =>
    item.id === productId ? { ...item, quantity: Math.max(1, quantity) } : item
  );
  saveCartItems(updatedItems);
  return updatedItems;
};

export const getCartCount = () => {
  const cartItems = getCartItems();
  return cartItems.reduce((total, item) => total + (item.quantity || 1), 0);
};

export const clearCart = () => {
  saveCartItems([]);
};

